import React from "react";
import { FiDownload, FiFileText, FiCalendar, FiCheckCircle } from "react-icons/fi";

const FORMAT_COLORS = { PDF: "#ef4444", CSV: "#10b981", Excel: "#3b82f6" };

const SCHEDULED = [
  { id: "SR-01", name: "Daily AQI Summary",         freq: "Daily 07:00",  recipients: "management@hq.local",    lastSent: "Today 07:00",   status: "Active" },
  { id: "SR-02", name: "Weekly Indoor Health Report",freq: "Monday 08:00", recipients: "hr@hq.local",            lastSent: "Mon 24 Feb",    status: "Active" },
  { id: "SR-03", name: "Monthly HVAC Performance",  freq: "Monthly 1st",  recipients: "facilities@hq.local",    lastSent: "01 Feb 2026",   status: "Active" },
  { id: "SR-04", name: "CPCB Compliance Report",    freq: "Monthly 1st",  recipients: "compliance@hq.local",    lastSent: "01 Feb 2026",   status: "Paused" },
];

const AqmReportsPanel = ({ d }) => (
  <div className="aqm-reports-panel">
    <div className="aqm-section-title">Reports &amp; Data Export</div>
    <div className="aqm-section-sub">Download air quality monitoring reports in PDF, CSV or Excel format</div>

    <div className="aqm-report-grid">
      {d.reports.map(r => (
        <div key={r.id} className="aqm-report-card">
          <div className="aqm-rc-top">
            <FiFileText size={20} color="#667eea" />
            <div>
              <div className="aqm-rc-name">{r.name}</div>
              <div className="aqm-rc-desc">{r.desc}</div>
            </div>
          </div>
          <div className="aqm-rc-footer">
            <span className="aqm-rc-gen">Generated: {r.generated}</span>
            <div className="aqm-rc-btns">
              {r.formats.map(fmt => (
                <button key={fmt} className="aqm-dl-btn" style={{ background: FORMAT_COLORS[fmt] + "18", color: FORMAT_COLORS[fmt], borderColor: FORMAT_COLORS[fmt] }}>
                  <FiDownload size={12} /> {fmt}
                </button>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>

    <div className="aqm-section-title" style={{ marginTop: 24 }}>
      <FiCalendar size={15} style={{ marginRight: 6, verticalAlign: "middle" }} />
      Scheduled Auto-Reports
    </div>
    <div className="aqm-sched-report-table">
      <div className="aqm-srt-header">
        <span>Report Name</span>
        <span>Frequency</span>
        <span>Recipients</span>
        <span>Last Sent</span>
        <span>Status</span>
      </div>
      {SCHEDULED.map(sr => (
        <div key={sr.id} className="aqm-srt-row">
          <span className="aqm-srt-name">{sr.name}</span>
          <span style={{ fontSize: 12, color: "#6b7280" }}>{sr.freq}</span>
          <span style={{ fontSize: 11, color: "#9ca3af" }}>{sr.recipients}</span>
          <span style={{ fontSize: 12, color: "#6b7280" }}>{sr.lastSent}</span>
          <span className={`aqm-badge ${sr.status === "Active" ? "aqm-badge-green" : "aqm-badge-gray"}`}>
            {sr.status === "Active" && <FiCheckCircle size={11} style={{ marginRight: 3 }} />}
            {sr.status}
          </span>
        </div>
      ))}
    </div>

    <div className="aqm-compliance-note">
      <FiFileText size={14} color="#667eea" />
      Reports are generated from live sensor data and archived for 3 years for regulatory compliance.
      Contact admin to configure custom schedules, add recipients, or set up SMS/WhatsApp alerts.
    </div>
  </div>
);

export default AqmReportsPanel;
